// NOTE(jonty): A debounced write echoes back through the URL. Adopting that
// echo would wipe keystrokes typed while the update was in flight.
export function shouldAdoptSearchUrl(
  urlValue: string,
  localValue: string,
  emittedUrlValue: string | null
): boolean {
  if (urlValue === emittedUrlValue) return false;
  return urlValue !== localValue;
}
